// Central brand + hero image assets for PurposePoint Collective
const BASE =
  "https://static.prod-images.emergentagent.com/jobs/1c646e73-3991-4deb-9e9d-27e0d854e41a/images";

export const ASSETS = {
  logoPP: `${BASE}/123e45793eb44163d2aeb575419cdc46a868ea73d2eca6c26bb4efe543b2c5cf.jpeg`,
  logoCCC: `${BASE}/249c2e43409fd69485cc19f183ea589a3af852754c2182117f71e5a5eacaf6db.jpeg`,
  craftyHero: `${BASE}/07cc8088fbce22ae8516c7450590d0c54772d5853657788fbb3883885eb4cad8.jpeg`,
  serveCpr: `${BASE}/e160201d3e0f6c8cddbfb8a60037a779d6bc1ed310e8819cecd9c66da2b76c1f.jpeg`,
  serveNotary: `${BASE}/42ddddbf593a189b331afbf9efda1d4daf713fdeaaa08a7749c7f313a09e1fd7.jpeg`,
  heroMemphis:
    "https://images.unsplash.com/photo-1577055383519-ca48a5d859be?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920",
  quoteBridge:
    "https://images.unsplash.com/photo-1600187230702-5f07aea6d7f2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920",

  // Nurfia-style editorial redesign imagery
  nHero1: "https://images.unsplash.com/photo-1672302255324-28009cc288b2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920",
  nHero2: "https://images.unsplash.com/photo-1562157873-818bc0726f68?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920",
  nHero3: "https://images.unsplash.com/photo-1617118601021-4992c028fe5d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920",
  nApparel: "https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  nGifts: "https://images.unsplash.com/photo-1707944145479-12755f0434d8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  nLooks: "https://images.unsplash.com/photo-1522065893269-6fd20f6d7438?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920",
  nStoryA: "https://images.unsplash.com/photo-1534953342533-7711c98712be?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  nStoryB: "https://images.unsplash.com/photo-1626252685663-64c6bf60afb1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  nAvatar1: "https://images.unsplash.com/photo-1580489944761-15a19d654956?crop=entropy&cs=srgb&fm=jpg&q=85&w=400",
  nAvatar2: "https://images.unsplash.com/photo-1662850886700-4ec19bd30d11?crop=entropy&cs=srgb&fm=jpg&q=85&w=400",
  nAvatar3: "https://images.unsplash.com/photo-1630939687530-241d630735df?crop=entropy&cs=srgb&fm=jpg&q=85&w=400",
  nJournal1: "https://images.unsplash.com/photo-1605971361644-0370a806c051?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  nJournal2: "https://images.unsplash.com/photo-1506806732259-39c2d0268443?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  nJournal3: "https://images.unsplash.com/photo-1607752312075-3d4a7fa7c9ae?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
};
